export default function FormInputDescription({ children }: { children: React.ReactNode }) {
    return <p className='text-theme-400 mt-1 text-sm'>{children}</p>;
}
